// ============================================================================
// Entity: UserGroups
// Key: userGroups
// Kind: entity
// Generated file. Do not edit manually.
// ============================================================================

import {
	getUserGroupsClientGetQueryKey,
	getUserGroupsClientGetQueryOptions,
} from '../api/backstage'
// #region Imports
import type { UserGroupSummary } from '../api/backstage.schemas'
import type { EntityConfig } from './entity-config.types'
import { defineQueryEndpoint } from './entity-config.types'

// #endregion

// #region Entity Endpoints
const userGroupsEntityEndpoints = {} as const
// #endregion

// #region Client Endpoints
const userGroupsClientEndpoints = {
	get: defineQueryEndpoint<UserGroupSummary[], undefined, undefined>({
		key: 'userGroups.client.get',
		method: 'GET',
		path: '/api/usergroups',
		queryKey: (_args) => getUserGroupsClientGetQueryKey(),
		queryOptions: (_args) => getUserGroupsClientGetQueryOptions(),
	}),
} as const
// #endregion

// #region Entity Config Export
export const userGroupsEntityConfig = {
	key: 'userGroups',
	kind: 'entity',
	entity: {
		idField: 'id',
		routePath: '/userGroups',
	},
	endpoints: userGroupsEntityEndpoints,
	client: userGroupsClientEndpoints,
} as const satisfies EntityConfig<'userGroups'>
// #endregion
